import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-property-detail',
  templateUrl: './skeleton-property-detail.component.html',
  styleUrls: ['./skeleton-property-detail.component.scss'],
  standalone: false
})
export class SkeletonPropertyDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
